import { t as e } from "./icon-cCgUPjwx.js";
import t from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import i from "lodash.uniqueid";
var a = {
	textInput: "_textInput_z7fc1_1",
	labelWrapper: "_labelWrapper_z7fc1_14",
	label: "_label_z7fc1_14",
	asterisk: "_asterisk_z7fc1_31",
	textInputWrapper: "_textInputWrapper_z7fc1_47",
	input: "_input_z7fc1_51",
	error: "_error_z7fc1_101",
	valid: "_valid_z7fc1_107",
	icon: "_icon_z7fc1_114",
	checkmark: "_checkmark_z7fc1_121"
}, o = ({ hasError: o = !1, inputClassName: s, isRequired: c = !1, isValid: l, labelName: u, name: d, onBlur: f, onChange: p, placeholder: m = "", shouldAutocomplete: h = !0, shouldUseUniqueId: g, type: _, value: v, wrapperClassName: y, ...b }) => {
	let [x, S] = t.useState(v);
	t.useEffect(() => {
		S(v);
	}, [v]);
	let C = (e) => {
		S(e.target.value), p && p(e);
	}, w = (e) => {
		f && f(e);
	}, T = () => _ && u ? /* @__PURE__ */ r("div", {
		className: a.labelWrapper,
		children: [/* @__PURE__ */ n("label", {
			className: a.label,
			htmlFor: _,
			children: u
		}), c && /* @__PURE__ */ n("span", {
			className: a.asterisk,
			children: "*"
		})]
	}) : null, E = () => l || o ? /* @__PURE__ */ n("div", {
		className: a.icon,
		children: o ? /* @__PURE__ */ n(e, {
			height: 20,
			icon: "ErrorCircle",
			width: 20
		}) : /* @__PURE__ */ n("div", {
			className: a.checkmark,
			children: /* @__PURE__ */ n(e, {
				fill: "#fff",
				height: 20,
				icon: "Checkmark",
				width: 20
			})
		})
	}) : null, D = _ === "password" ? "current-password" : _, O = `${a.input} ${o ? a.error : ""} ${l ? a.valid : ""} ${s}`;
	return /* @__PURE__ */ r("div", {
		className: a.textInput,
		children: [T(), /* @__PURE__ */ r("div", {
			className: `${a.textInputWrapper} ${y}`,
			children: [/* @__PURE__ */ n("input", {
				autoComplete: h ? D : "off",
				className: O,
				id: g ? i(`${d}_`) : d,
				name: d,
				onBlur: w,
				onChange: C,
				placeholder: m,
				type: _,
				value: x || "",
				...b
			}), E()]
		})]
	});
};
//#endregion
export { o as t };
